
import useInfiniteScroll from "../../../hooks/useInfiniteScroll";
import React, { FC, useState, useEffect, memo, useMemo } from "../../../lib/teact/teact";
import InfiniteScroll from "../../ui/InfiniteScroll";
import Modal from "../../ui/Modal";
import { globalDexieDb } from "../db/DexiedbLib";
import { IErrorLog } from "../db/model/errorLogs";


type OwnProps = {
    isOpen: boolean;
    onClose: () => void;
};

const ErrorViewer: FC<OwnProps> = ({ isOpen,
    onClose,
}) => {
    const [state, setState] = useState({
        errors: [] as any[]
    });
    useEffect(() => {
        globalDexieDb.errorLogs.toArray().then((errors) => {
            setState({ errors });
        });
    }, []);
    const buildListIds = useMemo(() => {
        const ids: number[] = [];
        for (let i = 0; i < state.errors.length; i++) {
            ids.push(i);
        }
        return ids;
    }, [state.errors])
    const [viewportIds, getMore] = useInfiniteScroll(undefined, buildListIds, false, 100);

    return (
        <Modal onClose={onClose}
            isOpen={isOpen}>
            <div className="error-viewer">
                <InfiniteScroll items={viewportIds} onLoadMore={getMore}
                    className="chat-list custom-scroll"
                    style="height:100%;"
                >
                    {
                        viewportIds && viewportIds.map((index: number) => {
                            const error = state.errors[index];
                            return (
                                <div key={index} className="error-display-card" >
                                    <div>
                                        {error.time}
                                    </div>
                                    <div>
                                        {(error.error?.message) ? error.error?.message : JSON.stringify(error.error)}
                                    </div>
                                    <div>
                                        {error.error?.stack}
                                    </div>

                                </div>)
                        })
                    }
                </InfiniteScroll>
            </div>
        </Modal>
    );
}

export default memo(ErrorViewer);